import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ArrowLeftIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLanguage } from '../hooks/useLanguage';
export function TrustedSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const {
    t,
    direction,
    locale
  } = useLanguage();
  const ArrowIcon = direction === 'rtl' ? ArrowLeftIcon : ArrowRightIcon;
  return <section className="relative py-24 text-white overflow-hidden" dir={direction} data-id="element-400">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/aNushftuwBdDBhG34PgQWF/Trusted.jpg')",
      transform: direction === 'rtl' ? 'scaleX(-1)' : 'none'
    }} data-id="element-401"></div>

      <div ref={ref} className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-402">
        <div className="" data-id="element-403">
          <h2 className={`text-4xl md:text-5xl font-bold mb-6 reveal-hidden ${isVisible ? 'animate-fade-left' : ''} whitespace-pre-line`} data-id="element-404">
            {t('trusted.title')}
          </h2>
          <p className={`text-white max-w-[950px] text-lg mb-8 leading-relaxed reveal-hidden ${isVisible ? 'animate-fade-left delay-200' : ''}`} data-id="element-405">
            {t('trusted.description')}
          </p>
          <Link to={locale === 'ar' ? '/ar/partners' : '/partners'} className={`btn-primary reveal-hidden ${isVisible ? 'animate-fade-up delay-400' : ''}`} data-id="element-406">
            {t('trusted.learnMore')}
            <ArrowIcon className="w-4 h-4" data-id="element-407" />
          </Link>
        </div>
      </div>
    </section>;
}